import { type ActiveState, createEntityStore, type EntityState, type EntityStore } from '@datorama/akita';
import { type UIPeriod } from 'types/models';

export interface UIPeriodsState extends EntityState<UIPeriod>, ActiveState {}

const store: EntityStore<UIPeriodsState> = createEntityStore({}, { resettable: true, name: 'uiperiods' });

export default store;
